import { Condominium } from '../../../../../../entities';

export type Configs = Pick<
  Condominium,
  | 'isBikesEnabled'
  | 'isSignupEnabled'
  | 'isEmergencyEnabled'
  | 'isChatEnabled'
  | 'isReservationsEnabled'
  | 'reservationMaxPeriod'
  | 'isFeedEnabled'
  | 'isGuestsEnabled'
  | 'isHelpEnabled'
  | 'isPackagesEnabled'
  | 'isDwellerPostEnabled'
  | 'isDwellerCommentEnabled'
  | 'isDisabled'
  | 'laundryId'
  | 'type'
  | 'furnitureId'
  | 'cleaningId'
  | 'maidId'
>;

export enum ConfigurationType {
  Setup = 'Setup',
  Facilities = 'Facilities',
  Partners = 'Partners'
}
